module.exports = __webpack_public_path__ + "img/14.e0843e0a.jpg";